import { Callout, ComboBox, DetailsList, DetailsListLayoutMode, Selection, SelectionMode, TextField } from "@fluentui/react";
import React, { useEffect, useRef, useState } from 'react';
import { Grid } from "./Grid";
import { Row } from "./Row";
import { Column } from "./Column";
export const SearchableComboBox = function SearchableComboBox(props) {
    const ref = useRef(null);
    const [search, setSearch] = useState('');
    const [fluentOptions, setFluentOptions] = useState([]);
    useEffect(() => {
        const cbxOptions = (props.options || [])
            .filter(x => props.keyBinding(x) == props.selectedKey)
            .map(x => ({ key: props.keyBinding(x), text: props.onRenderSelectedText(x) }));
        setFluentOptions(cbxOptions);
    }, [props.options, props.selectedKey]);
    const filterOptions = () => {
        let filteredItems = props.onFilter != null ? (props.options || []).filter(x => props.onFilter(x) || false) : (props.options || []);
        const nSearch = search === null || search === void 0 ? void 0 : search.trim().toLowerCase();
        filteredItems = (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.filter(item => props.onSearch(nSearch, item))) || [];
        return [props.defaultItem].concat(filteredItems);
    };
    const options = filterOptions();
    return React.createElement("div", { ref: ref }, React.createElement(ComboBox, { required: props.required || false, label: props.label, ref: ref, disabled: props.disabled, useComboBoxAsMenuWidth: true, errorMessage: props.errorMessage, onRenderContainer: (context) => {
            var _a, _b, _c, _d, _e;
            const w = ((_e = (_d = (_c = (_b = (_a = context === null || context === void 0 ? void 0 : context.hoisted) === null || _a === void 0 ? void 0 : _a.rootRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect) === null || _d === void 0 ? void 0 : _d.call(_c)) === null || _e === void 0 ? void 0 : _e.width) || 'auto';
            const selection = new Selection({
                onSelectionChanged: () => {
                    const selectedItem = selection.getSelection()[0];
                    if (selectedItem != undefined) {
                        selection.setAllSelected(false);
                        setSearch('');
                        props.onChanged(selectedItem);
                        context.onDismiss();
                    }
                },
            });
            return React.createElement("div", { tabIndex: 0 },
                React.createElement(Callout, { onDismiss: () => context.onDismiss(), target: ref.current },
                    React.createElement("div", { style: { maxHeight: '600px', display: 'grid', gridTemplateRows: '40px 1fr', overflow: 'hidden', height: 'auto', width: '100%', minWidth: `${w}px` } },
                        React.createElement("div", { style: { height: '40px', padding: '5px', zIndex: 1 } },
                            React.createElement(Grid, null,
                                React.createElement(Row, null,
                                    React.createElement(Column, { size: 12 },
                                        React.createElement(TextField, { placeholder: 'Buscar', onChange: (_, value) => setSearch(value), maxLength: 64, value: search || '', autoFocus: true }))))),
                        React.createElement("div", { style: { height: 'calc(100% - 10px)', overflow: 'scroll', padding: '5px' } },
                            React.createElement(DetailsList, { columns: props.columns || [], compact: true, enterModalSelectionOnTouch: true, isHeaderVisible: true, items: options, layoutMode: DetailsListLayoutMode.fixedColumns, selection: selection, selectionMode: SelectionMode.single, selectionPreservedOnEmptyClick: true })))));
        }, options: fluentOptions, selectedKey: props.selectedKey }));
};
